/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React, { useState } from 'react';
import { Button } from '../../../../components/buttons/Button';
import { TaskExecutionController } from '@karya/generic-task-react';
import { Text } from '../../../../components/Text';
import { Box } from 'chakra-v3';

interface SubmitTaskButtonProps {
  controller: TaskExecutionController;
  label?: string;
}

export const SubmitTaskButton: React.FC<SubmitTaskButtonProps> = ({ controller, label = 'Continue' }) => {
  const [error, setError] = useState<Error | string | null>(null);

  const handleClick = () => {
    setError(null);
    try {
      controller.next();
    } catch (e) {
      if (e instanceof Error) {
        setError(e);
      } else {
        setError('An unknown error occurred during submission.');
      }
    }
  };

  return (
    <Box w="100%" mt="16px" display="flex" flexDirection="column" alignItems="flex-end">
      {error && (
        <Text variant="body" color="error.solid" mb="8px">
          {typeof error === 'string' ? error : error.message}
        </Text>
      )}
      <Button onClick={handleClick} variant="secondary" w="fit-content" minW="120px">
        {label}
      </Button>
    </Box>
  );
};
